export default {
    // 中
    zhCN: {
        vin: 'VIN',
        productionTimeList: '生产时间清单',
        vehicle_configuration_list: '车辆配置清单',
        accurately_traceable_parts_list: '精确追溯零件清单',
        order_number: '订单号',
        order_type: '订单类型',
        platform: '平台',
        model_code: '车型代码',
        date_of_production: '生产日期',
        certificate_of_conformity: '合格证号',
        certificate_printing_time: '合格证打印时间',
        vehicle_material_number: '车辆物料号',
        description: '描述',
        time: '时间',
        feature_ID: '特征ID',
        feature_description: '特征描述',
        feature_code: '特征码',
        eigenvalue_description: '特征值描述',
        chinese_description: '中文描述',
        supplier: '供应商',
        bar_code_number: '条码编号',
        scanning_time: '扫描时间',
        key_component_type_code: '关键件类型编码',
        part_number: '零件号',
        traceability_number: '追溯号',
        sub_key_type: '子关键件类型',
        software: '软件',
        hardware: '硬件',
        calibration_information: '标定信息',
        supplier_name: '供应商号',
        pn: 'PIN码',
    },
    // 英
    enUS: {
        vin: 'VIN',
        productionTimeList: 'Production date list',
        vehicle_configuration_list: 'Vehicle configuration list',
        accurately_traceable_parts_list: 'Traceable parts list',
        order_number: 'Order #',
        order_type: 'Order type',
        platform: 'Platform',
        model_code: 'Model code',
        date_of_production: 'Date of production',
        certificate_of_conformity: 'COC #',
        certificate_printing_time: 'COC print timee',
        vehicle_material_number: 'Vehicle material code',
        description: 'Description',
        time: 'Time',
        feature_ID: 'Feature ID',
        feature_description: 'Feature description',
        feature_code: 'Feature code',
        eigenvalue_description: 'Feature description',
        chinese_description: 'Chinese description',
        supplier: 'Supplier',
        bar_code_number: 'Bar code number',
        scanning_time: 'Scanning time',
        key_component_type_code: 'Key component type code',
        part_number: 'Part number',
        traceability_number: 'Traceability number',
        sub_key_type: 'Sub key type',
        software: 'Software',
        hardware: 'Hardware',
        calibration_information: 'Calibration information',
        supplier_name: 'Supplier name',
        pn: 'PIN code',
    },
    // 德
    deDE: {
        vin: 'VIN',
        productionTimeList: 'Produktionszeitliste',
        vehicle_configuration_list: 'Fahrzeugkonfigurationsliste',
        accurately_traceable_parts_list: 'Genau nachverfolgbare Teileliste',
        order_number: 'Bestellnummer',
        order_type: 'Bestelltyp',
        platform: 'Plattform',
        model_code: 'Modellcode',
        date_of_production: 'Produktionsdatum',
        certificate_of_conformity: 'Konformitätsbescheinigung',
        certificate_printing_time: 'Zeitpunkt des Zertifikatsdrucks',
        vehicle_material_number: 'Fahrzeugmaterialnummer',
        description: 'Beschreibung',
        time: 'Zeit',
        feature_ID: 'Merkmals-ID',
        feature_description: 'Merkmalsbeschreibung',
        feature_code: 'Merkmalcode',
        eigenvalue_description: 'Eigenwertbeschreibung',
        chinese_description: 'Chinesische Beschreibung',
        supplier: 'Lieferant',
        bar_code_number: 'Barcode-Nummer',
        scanning_time: 'Scanzeit',
        key_component_type_code: 'Code des Schlüsselkomponententyps',
        part_number: 'Teilenummer',
        traceability_number: 'Rückverfolgbarkeitsnummer',
        sub_key_type: 'Untertyp des Schlüssels',
        software: 'Software',
        hardware: 'Hardware',
        calibration_information: 'Kalibrierungsinformationen',
        supplier_name: 'Lieferantenname',
        pn: 'PIN-Code',
    },
    // 法
    frFR: {
        vin: 'VIN',
        productionTimeList: 'Date de production',
        vehicle_configuration_list: 'Configuration véhicule',
        accurately_traceable_parts_list: 'Suivi des pièces',
        order_number: 'Numéro de commande',
        order_type: 'Type de commande',
        platform: 'Plateforme',
        model_code: 'Code modèle',
        date_of_production: 'Date de production',
        certificate_of_conformity: 'Numéro de COC',
        certificate_printing_time: 'Date d\'impression du COC',
        vehicle_material_number: 'Code du matériel véhicule',
        description: 'Description',
        time: 'Date',
        feature_ID: 'Nom de la fonctionnalité',
        feature_description: 'Description de la fonctionnalité',
        feature_code: 'Code de la fonctionnalité',
        eigenvalue_description: 'Description de valeur propre',
        chinese_description: 'Description',
        supplier: 'Fournisseur',
        bar_code_number: 'Numéro de code barre',
        scanning_time: 'Date de scan',
        key_component_type_code: 'Code de type de composant clé',
        part_number: 'Numéro de pièce',
        traceability_number: 'Numéro de traçabilité',
        sub_key_type: 'Sous-type de clé',
        software: 'Logiciel',
        hardware: 'Matériel',
        calibration_information: 'Informations de calibration',
        supplier_name: 'Nom du fournisseur',
        pn: 'Code PIN',
    },
    // 意大利
    itIT: {
        vin: 'VIN',
        productionTimeList: 'Elenco tempi di produzione',
        vehicle_configuration_list: 'Elenco configurazioni veicolo',
        accurately_traceable_parts_list: 'Elenco parti accuratamente rintracciabili',
        order_number: 'Numero d\'ordine',
        order_type: 'Tipo d\'ordine',
        platform: 'Piattaforma',
        model_code: 'Codice modello',
        date_of_production: 'Data di produzione',
        certificate_of_conformity: 'Certificato di conformità',
        certificate_printing_time: 'Tempo di stampa del certificato',
        vehicle_material_number: 'Numero materiale veicolo',
        description: 'Descrizione',
        time: 'Tempo',
        feature_ID: 'ID funzione',
        feature_description: 'Descrizione funzione',
        feature_code: 'Codice funzione',
        eigenvalue_description: 'Descrizione valore caratteristico',
        chinese_description: 'Descrizione cinese',
        supplier: 'Fornitore',
        bar_code_number: 'Numero codice a barre',
        scanning_time: 'Tempo di scansione',
        key_component_type_code: 'Codice tipo componente chiave',
        part_number: 'Numero parte',
        traceability_number: 'Numero tracciabilità',
        sub_key_type: 'Sotto-tipo chiave',
        software: 'Software',
        hardware: 'Hardware',
        calibration_information: 'Informazioni di calibrazione',
        supplier_name: 'Nome fornitore',
        pn: 'Codice PIN',
    },
    // 荷兰
    nlNL: {
        vin: 'VIN',
        productionTimeList: 'Productietijdlijst',
        vehicle_configuration_list: 'Voertuigconfiguratielijst',
        accurately_traceable_parts_list: 'Nauwkeurig traceerbare onderdelenlijst',
        order_number: 'Bestelnummer',
        order_type: 'Besteltype',
        platform: 'Platform',
        model_code: 'Modelcode',
        date_of_production: 'Productiedatum',
        certificate_of_conformity: 'Certificaat van overeenstemming',
        certificate_printing_time: 'Tijd van afdrukken certificaat',
        vehicle_material_number: 'Voertuigmateriaalnummer',
        description: 'Beschrijving',
        time: 'Tijd',
        feature_ID: 'Kenmerk ID',
        feature_description: 'Kenmerkbeschrijving',
        feature_code: 'Kenmerkcode',
        eigenvalue_description: 'Eigenwaarde beschrijving',
        chinese_description: 'Chinese beschrijving',
        supplier: 'Leverancier',
        bar_code_number: 'Barcode nummer',
        scanning_time: 'Scan tijd',
        key_component_type_code: 'Code van sleutelcomponenttype',
        part_number: 'Onderdeelnummer',
        traceability_number: 'Traceerbaarheidsnummer',
        sub_key_type: 'Subsleuteltype',
        software: 'Software',
        hardware: 'Hardware',
        calibration_information: 'Kalibratie informatie',
        supplier_name: 'Leveranciersnaam',
        pn: 'PIN-code',
    },
    // 越南
    viVN: {
        vin: 'Số khung',
        productionTimeList: 'Danh sách ngày sản xuất',
        vehicle_configuration_list: 'Danh sách thông tin kỹ thuật của xe',
        accurately_traceable_parts_list: 'Danh sách các phụ tùng có thể truy xuất nguồn gốc',
        order_number: 'Số đơn hàng',
        order_type: 'Loại đơn hàng',
        platform: 'Nền tảng',
        model_code: 'Mã loại',
        date_of_production: 'Ngày sản xuất',
        certificate_of_conformity: 'Số tờ khai nguồn gốc COC',
        certificate_printing_time: 'Thời gian in tờ khai nguồn gốc COC',
        vehicle_material_number: 'Mã vật liệu xe',
        description: 'Mô tả',
        time: 'Thời gian',
        feature_ID: 'Mã số tính năng',
        feature_description: 'Mô tả tính năng',
        feature_code: 'Mã tính năng',
        eigenvalue_description: 'Mô ta tính năng',
        chinese_description: 'Mô tả bằng tiếng Trung Quốc',
        supplier: 'Nhà cung cấp',
        bar_code_number: 'Số mã vạch',
        scanning_time: 'Thời gian quét',
        key_component_type_code: 'Mã loại thành phần chính',
        part_number: 'Số lượng linh kiện',
        traceability_number: 'Số theo dõi',
        sub_key_type: 'Loại thành phần chính phụ',
        software: 'Phần mềm',
        hardware: 'Phần cứng',
        calibration_information: 'Thông tin hiệu chuẩn',
        supplier_name: 'Tên nhà cung cấp',
        pn: 'Mã PIN',
    },
    // 西班牙
    esES: {
        vin: 'VIN',
        productionTimeList: 'Lista de Tiempo de Producción',
        vehicle_configuration_list: 'Lista de Configuración del Vehículo',
        accurately_traceable_parts_list: 'Lista de Piezas con Trazabilidad Exacta',
        order_number: 'Número de Orden',
        order_type: 'Tipo de Orden',
        platform: 'Plataforma',
        model_code: 'Código de Modelo de Vehículo',
        date_of_production: 'Fecha de Producción',
        certificate_of_conformity: 'Número de Certificado de Calidad',
        certificate_printing_time: 'Fecha de Impresión del Certificado de Calidad',
        vehicle_material_number: 'Número de Material del Vehículo',
        description: 'Descripción',
        time: 'Tiempo',
        feature_ID: 'ID de Característica',
        feature_description: 'Descripción de Característica',
        feature_code: 'Código de Característica',
        eigenvalue_description: 'Descripción de Valor de Característica',
        chinese_description: 'Descripción en Chino',
        supplier: 'Proveedor',
        bar_code_number: 'Número de Código de Barras',
        scanning_time: 'Fecha de Escaneo',
        key_component_type_code: 'Código de Tipo de Pieza Clave',
        part_number: 'Número de Pieza',
        traceability_number: 'Número de Rastreo',
        sub_key_type: 'Subtipo de Pieza Clave',
        software: 'Software',
        hardware: 'Hardware',
        calibration_information: 'Información de Calibración',
        supplier_name: 'Número de Proveedor',
        pn: 'Código PIN',
    },
    // 葡萄牙
    ptBR: {
        vin: 'VIN',
        productionTimeList: 'Lista de tempo de produção',
        vehicle_configuration_list: 'Lista de configuração do veículo',
        accurately_traceable_parts_list: 'Lista de peças rastreáveis com precisão',
        order_number: 'Número do pedido',
        order_type: 'Tipo de pedido',
        platform: 'Plataforma',
        model_code: 'Código do modelo',
        date_of_production: 'Data de produção',
        certificate_of_conformity: 'Certificado de conformidade',
        certificate_printing_time: 'Tempo de impressão do certificado',
        vehicle_material_number: 'Número de material do veículo',
        description: 'Descrição',
        time: 'Tempo',
        feature_ID: 'ID da característica',
        feature_description: 'Descrição da característica',
        feature_code: 'Código da característica',
        eigenvalue_description: 'Descrição do valor característico',
        chinese_description: 'Descrição em chinês',
        supplier: 'Fornecedor',
        bar_code_number: 'Número de código de barras',
        scanning_time: 'Tempo de digitalização',
        key_component_type_code: 'Código do tipo de componente chave',
        part_number: 'Número da peça',
        traceability_number: 'Número de rastreabilidade',
        sub_key_type: 'Subtipo de componente chave',
        software: 'Software',
        hardware: 'Hardware',
        calibration_information: 'Informação de calibração',
        supplier_name: 'Nome do fornecedor',
        pn: 'Código PIN',
    },
    // 波兰
    plPL: {
        vin: 'VIN',
        productionTimeList: 'Lista czasu produkcji',
        vehicle_configuration_list: 'Lista konfiguracji pojazdu',
        accurately_traceable_parts_list: 'Identyfikowalna lista części',
        order_number: 'Zamówienie #',
        order_type: 'Typ zamówienia',
        platform: 'Platforma',
        model_code: 'Kod modelu',
        date_of_production: 'Data produkcji',
        certificate_of_conformity: 'COC #',
        certificate_printing_time: 'Data druku COC',
        vehicle_material_number: 'Kod materiałowy pojazdu',
        description: 'Opis',
        time: 'Czas',
        feature_ID: 'Identyfikator właściwości',
        feature_description: 'Opis właściwości',
        feature_code: 'Kod właściwości',
        eigenvalue_description: 'Opis właściwości',
        chinese_description: 'Opis chiński',
        supplier: 'Dostawca',
        bar_code_number: 'Numer kodu kreskowego',
        scanning_time: 'Data skanowania',
        key_component_type_code: 'Kod typu kluczowego komponentu',
        part_number: 'Numer części',
        traceability_number: 'Numer identyfikacyjny',
        sub_key_type: 'Typ klucza podrzędnego',
        software: 'Oprogramowanie',
        hardware: 'Sprzęt',
        calibration_information: 'Informacjie o kalibracji',
        supplier_name: 'Nazwa dostawcy',
        pn: 'Kod PIN',
    },
    // 土耳其
    trTR: {
        vin: 'VIN',
        productionTimeList: 'Üretim Tarih Listesi',
        vehicle_configuration_list: 'Araç  donanım listesi',
        accurately_traceable_parts_list: 'İzlenebilen parçalar listesi',
        order_number: 'Sipariş',
        order_type: 'Sipariş tipi',
        platform: 'Platform',
        model_code: 'Model kodu',
        date_of_production: 'Üretim tarihi',
        certificate_of_conformity: 'COC #',
        certificate_printing_time: 'COC yazdırma zamanı',
        vehicle_material_number: 'Araç malzemel kodu',
        description: 'Açıklama',
        time: 'Zaman',
        feature_ID: 'Özellik Kimliği',
        feature_description: 'Özellik  açıklaması',
        feature_code: 'Özellik kodu',
        eigenvalue_description: 'Özellik tanıtımı',
        chinese_description: 'Çin\'ce açıklama',
        supplier: 'Sağlayıcı',
        bar_code_number: 'Bar kodu numarası',
        scanning_time: 'Tarama zamanı',
        key_component_type_code: 'Anahtar komponent tipi kodu',
        part_number: 'Bölüm Numarası',
        traceability_number: 'İzlenebileceği Numarası',
        sub_key_type: 'Alt Anahtar Türü',
        software: 'Yazılım',
        hardware: 'Hardware',
        calibration_information: 'Kalibrasyon bilgisi',
        supplier_name: 'Sağlayıcı ismi',
        pn: 'PIN kodu',
    },
    // 捷克语
    csCZ: {
        vin: 'VIN',
        productionTimeList: 'Seznam dat výroby',
        vehicle_configuration_list: 'Seznam konfigurace vozidla',
        accurately_traceable_parts_list: 'Vysledovatelný seznam dílů',
        order_number: 'Objednat #',
        order_type: 'Typ objednávky',
        platform: 'Platforma',
        model_code: 'Kód modelu',
        date_of_production: 'Datum výroby',
        certificate_of_conformity: 'COC #',
        certificate_printing_time: 'Doba tisku COC',
        vehicle_material_number: 'Kód materiálu vozidla',
        description: 'Popis',
        time: 'Čas',
        feature_ID: 'ID funkce',
        feature_description: 'Popis funkce',
        feature_code: 'Kód funkce',
        eigenvalue_description: 'Popis funkce',
        chinese_description: 'Čínský popis',
        supplier: 'Dodavatel',
        bar_code_number: 'Číslo čárového kódu',
        scanning_time: 'Doba skenování',
        key_component_type_code: 'Typový kód klíčové součásti',
        part_number: 'Číslo dílu',
        traceability_number: 'Číslo sledovatelnosti',
        sub_key_type: 'Dílčí typ klíče',
        software: 'Software',
        hardware: 'Hardware',
        calibration_information: 'Informace o kalibraci',
        supplier_name: 'Jméno dodavatele',
        pn: 'PIN',
    },
    // 匈牙利语
    huHU: {
        vin: 'Alvázszám',
        productionTimeList: 'Gyártási dátumlista',
        vehicle_configuration_list: 'Járműkonfigurációs lista',
        accurately_traceable_parts_list: 'Nyomon követhető alkatrészek listája',
        order_number: 'Rendeléssz.',
        order_type: 'Rendeléstípus',
        platform: 'Platform',
        model_code: 'Modellkód',
        date_of_production: 'Gyártási dátum',
        certificate_of_conformity: 'Megfelelőségi nyilatkozat sz.',
        certificate_printing_time: 'Megfelelőségi nyilatkozat nyomtatási ideje',
        vehicle_material_number: 'Jármű anyagkód',
        description: 'Leírás',
        time: 'Idő',
        feature_ID: 'Funkcióazonosító',
        feature_description: 'Funkcióleírás',
        feature_code: 'Funkciókód',
        eigenvalue_description: 'Funkcióleírás',
        chinese_description: 'Kínai leírás',
        supplier: 'Beszállító',
        bar_code_number: 'Vonalkód száma',
        scanning_time: 'Beolvasás ideje',
        key_component_type_code: 'Fődarab típuskódja',
        part_number: 'Alkatrészszám',
        traceability_number: 'Nyomkövetési szám',
        sub_key_type: 'Alegység típusa',
        software: 'Szoftver',
        hardware: 'Hardver',
        calibration_information: 'Kalibrációs információ',
        supplier_name: 'Beszállító neve',
        pn: 'PIN-kód',
    },
    // 俄罗斯语
    ruRU: {
        vin: 'VIN',
        productionTimeList: 'Список дат производства',
        vehicle_configuration_list: 'Список конфигураций автомобиля',
        accurately_traceable_parts_list: 'Список отслеживаемых деталей',
        order_number: 'Номер заказа',
        order_type: 'Тип заказа',
        platform: 'Платформа',
        model_code: 'Код модели',
        date_of_production: 'Дата производства',
        certificate_of_conformity: 'Номер COC',
        certificate_printing_time: 'Время печати COC',
        vehicle_material_number: 'Код материала автомобиля',
        description: 'Описание',
        time: 'Время',
        feature_ID: 'ID функции',
        feature_description: 'Описание функции',
        feature_code: 'Код функции',
        eigenvalue_description: 'Описание функции',
        chinese_description: 'Описание на китайском',
        supplier: 'Поставщик',
        bar_code_number: 'Номер штрих-кода',
        scanning_time: 'Время сканирования',
        key_component_type_code: 'Код типа ключевого компонента',
        part_number: 'Номер детали',
        traceability_number: 'Номер отслеживания',
        sub_key_type: 'Подтип ключа',
        software: 'Программное обеспечение',
        hardware: 'Аппаратное обеспечение',
        calibration_information: 'Информация о калибровке',
        supplier_name: 'Имя поставщика',
        pn: 'PIN код',
    },
    // 沙特阿拉伯
    arSA: {
        vin: 'VIN',
        productionTimeList: 'قائمة أوقات الإنتاج',
        vehicle_configuration_list: 'قائمة تكوين المركبة',
        accurately_traceable_parts_list: 'قائمة الأجزاء القابلة للتتبع بدقة',
        order_number: 'رقم الطلب',
        order_type: 'نوع الطلب',
        platform: 'المنصة',
        model_code: 'رمز الطراز',
        date_of_production: 'تاريخ الإنتاج',
        certificate_of_conformity: 'رقم شهادة المطابقة',
        certificate_printing_time: 'وقت طباعة الشهادة',
        vehicle_material_number: 'رقم مادة المركبة',
        description: 'الوصف',
        time: 'الوقت',
        feature_ID: 'معرّف السمة',
        feature_description: 'وصف السمة',
        feature_code: 'رمز السمة',
        eigenvalue_description: 'وصف القيمة الذاتية',
        chinese_description: 'الوصف بالصينية',
        supplier: 'المورّد',
        bar_code_number: 'رقم الباركود',
        scanning_time: 'وقت المسح',
        key_component_type_code: 'رمز نوع المكون الرئيسي',
        part_number: 'رقم القطعة',
        traceability_number: 'رقم التتبع',
        sub_key_type: 'نوع المكون الفرعي الرئيسي',
        software: 'البرمجيات',
        hardware: 'الأجهزة',
        calibration_information: 'معلومات المعايرة',
        supplier_name: 'اسم المورّد',
        pn: 'رمز PIN',
    },
    // 保加利亚
    bgBG: {
        vin: 'VIN',
        productionTimeList: 'Списък с времена на производство',
        vehicle_configuration_list: 'Списък с конфигурации на превозното средство',
        accurately_traceable_parts_list: 'Списък с точно проследими части',
        order_number: 'Номер на поръчка',
        order_type: 'Тип на поръчката',
        platform: 'Платформа',
        model_code: 'Код на модела',
        date_of_production: 'Дата на производство',
        certificate_of_conformity: 'Номер на сертификат за съответствие',
        certificate_printing_time: 'Време на отпечатване на сертификата',
        vehicle_material_number: 'Номер на материал за превозно средство',
        description: 'Описание',
        time: 'Време',
        feature_ID: 'ID на характеристика',
        feature_description: 'Описание на характеристика',
        feature_code: 'Код на характеристика',
        eigenvalue_description: 'Описание на собствена стойност',
        chinese_description: 'Китайско описание',
        supplier: 'Доставчик',
        bar_code_number: 'Номер на баркод',
        scanning_time: 'Време на сканиране',
        key_component_type_code: 'Код на тип ключов компонент',
        part_number: 'Номер на част',
        traceability_number: 'Номер за проследяване',
        sub_key_type: 'Тип подключов компонент',
        software: 'Софтуер',
        hardware: 'Хардуер',
        calibration_information: 'Информация за калибриране',
        supplier_name: 'Име на доставчик',
        pn: 'PIN код',
    },
    // 丹麦语
    daDK: {
        vin: 'VIN',
        productionTimeList: 'Produktionstidsliste',
        vehicle_configuration_list: 'Køretøjskonfigurationsliste',
        accurately_traceable_parts_list: 'Præcist sporbare dele liste',
        order_number: 'Ordrenummer',
        order_type: 'Ordretype',
        platform: 'Platform',
        model_code: 'Modelkode',
        date_of_production: 'Produktionsdato',
        certificate_of_conformity: 'Overensstemmelsesattestnummer',
        certificate_printing_time: 'Udskrivningstidspunkt for attest',
        vehicle_material_number: 'Køretøjsmateriale nummer',
        description: 'Beskrivelse',
        time: 'Tid',
        feature_ID: 'Funktions-ID',
        feature_description: 'Funktionsbeskrivelse',
        feature_code: 'Funktionskode',
        eigenvalue_description: 'Egen værdi beskrivelse',
        chinese_description: 'Kinesisk beskrivelse',
        supplier: 'Leverandør',
        bar_code_number: 'Stregkodenummer',
        scanning_time: 'Scanningstid',
        key_component_type_code: 'Nøglekomponent typekode',
        part_number: 'Reservedelsnummer',
        traceability_number: 'Sporbarhedsnummer',
        sub_key_type: 'Undernøglekomponenttype',
        software: 'Software',
        hardware: 'Hardware',
        calibration_information: 'Kalibreringsinformation',
        supplier_name: 'Leverandørnavn',
        pn: 'PIN-kode',
    },
    // 芬兰语
    fiFI: {
        vin: 'VIN',
        productionTimeList: 'Tuotantoaikataululista',
        vehicle_configuration_list: 'Ajoneuvon määrityslista',
        accurately_traceable_parts_list: 'Tarkasti jäljitettävien osien lista',
        order_number: 'Tilausnumero',
        order_type: 'Tilaustyyppi',
        platform: 'Alusta',
        model_code: 'Mallikoodi',
        date_of_production: 'Tuotantopäivämäärä',
        certificate_of_conformity: 'Yhdenmukaisuustodistuksen numero',
        certificate_printing_time: 'Todistuksen tulostusaika',
        vehicle_material_number: 'Ajoneuvomateriaalin numero',
        description: 'Kuvaus',
        time: 'Aika',
        feature_ID: 'Ominaisuustunnus',
        feature_description: 'Ominaisuuden kuvaus',
        feature_code: 'Ominaisuuskoodi',
        eigenvalue_description: 'Ominaisarvon kuvaus',
        chinese_description: 'Kiinalainen kuvaus',
        supplier: 'Toimittaja',
        bar_code_number: 'Viivakoodinumero',
        scanning_time: 'Skannausaika',
        key_component_type_code: 'Avainkomponentin tyyppikoodi',
        part_number: 'Osanumero',
        traceability_number: 'Jäljitettävyysnumero',
        sub_key_type: 'Aliavainkomponenttityyppi',
        software: 'Ohjelmisto',
        hardware: 'Laitteisto',
        calibration_information: 'Kalibrointitiedot',
        supplier_name: 'Toimittajan nimi',
        pn: 'PIN-koodi',
    },
    // 繁体中文台湾
    zhTW: {
        vin: 'VIN',
        productionTimeList: '生產時間清單',
        vehicle_configuration_list: '車輛配置清單',
        accurately_traceable_parts_list: '精確追溯零件清單',
        order_number: '訂單號',
        order_type: '訂單類型',
        platform: '平台',
        model_code: '車型代碼',
        date_of_production: '生產日期',
        certificate_of_conformity: '合格證號',
        certificate_printing_time: '合格證列印時間',
        vehicle_material_number: '車輛物料號',
        description: '描述',
        time: '時間',
        feature_ID: '特徵ID',
        feature_description: '特徵描述',
        feature_code: '特徵碼',
        eigenvalue_description: '特徵值描述',
        chinese_description: '中文描述',
        supplier: '供應商',
        bar_code_number: '條碼編號',
        scanning_time: '掃描時間',
        key_component_type_code: '關鍵件類型編碼',
        part_number: '零件號',
        traceability_number: '追溯號',
        sub_key_type: '子關鍵件類型',
        software: '軟體',
        hardware: '硬體',
        calibration_information: '標定資訊',
        supplier_name: '供應商名稱',
        pn: 'PIN碼',
    },
    // 克罗地亚
    hrHR: {
        vin: 'VIN',
        productionTimeList: 'Popis vremena proizvodnje',
        vehicle_configuration_list: 'Popis konfiguracija vozila',
        accurately_traceable_parts_list: 'Popis točno pratljivih dijelova',
        order_number: 'Broj narudžbe',
        order_type: 'Vrsta narudžbe',
        platform: 'Platforma',
        model_code: 'Kôd modela',
        date_of_production: 'Datum proizvodnje',
        certificate_of_conformity: 'Broj certifikata o sukladnosti',
        certificate_printing_time: 'Vrijeme ispisivanja certifikata',
        vehicle_material_number: 'Broj materijala vozila',
        description: 'Opis',
        time: 'Vrijeme',
        feature_ID: 'ID značajke',
        feature_description: 'Opis značajke',
        feature_code: 'Kôd značajke',
        eigenvalue_description: 'Opis svojstvene vrijednosti',
        chinese_description: 'Kineski opis',
        supplier: 'Dobavljač',
        bar_code_number: 'Broj barkoda',
        scanning_time: 'Vrijeme skeniranja',
        key_component_type_code: 'Kôd tipa ključne komponente',
        part_number: 'Broj dijela',
        traceability_number: 'Broj za praćenje',
        sub_key_type: 'Podvrsta ključne komponente',
        software: 'Softver',
        hardware: 'Hardver',
        calibration_information: 'Informacije o kalibraciji',
        supplier_name: 'Naziv dobavljača',
        pn: 'PIN kôd',
    },
    // 拉脱维亚
    lvLV: {
        vin: 'VIN',
        productionTimeList: 'Ražošanas laika saraksts',
        vehicle_configuration_list: 'Transportlīdzekļa konfigurācijas saraksts',
        accurately_traceable_parts_list: 'Precīzi izsekojamu detaļu saraksts',
        order_number: 'Pasūtījuma numurs',
        order_type: 'Pasūtījuma veids',
        platform: 'Platforma',
        model_code: 'Modeļa kods',
        date_of_production: 'Ražošanas datums',
        certificate_of_conformity: 'Atbilstības sertifikāta numurs',
        certificate_printing_time: 'Sertifikāta drukāšanas laiks',
        vehicle_material_number: 'Transportlīdzekļa materiāla numurs',
        description: 'Apraksts',
        time: 'Laiks',
        feature_ID: 'Funkcijas ID',
        feature_description: 'Funkcijas apraksts',
        feature_code: 'Funkcijas kods',
        eigenvalue_description: 'Īpašības vērtības apraksts',
        chinese_description: 'Ķīniešu valodas apraksts',
        supplier: 'Piegādātājs',
        bar_code_number: 'Svītrkoda numurs',
        scanning_time: 'Skenēšanas laiks',
        key_component_type_code: 'Galvenās komponentes tipa kods',
        part_number: 'Detaļas numurs',
        traceability_number: 'Izsekojamības numurs',
        sub_key_type: 'Apakšgalvenās komponentes tips',
        software: 'Programmatūra',
        hardware: 'Aparatūra',
        calibration_information: 'Kalibrācijas informācija',
        supplier_name: 'Piegādātāja nosaukums',
        pn: 'PIN kods',
    },
    // 立陶宛
    ltLT: {
        vin: 'VIN',
        productionTimeList: 'Gamybos laiko sąrašas',
        vehicle_configuration_list: 'Transporto priemonės konfigūracijos sąrašas',
        accurately_traceable_parts_list: 'Tiksliai sekamų detalių sąrašas',
        order_number: 'Užsakymo numeris',
        order_type: 'Užsakymo tipas',
        platform: 'Platforma',
        model_code: 'Modelio kodas',
        date_of_production: 'Gamybos data',
        certificate_of_conformity: 'Atitikties sertifikato numeris',
        certificate_printing_time: 'Sertifikato spausdinimo laikas',
        vehicle_material_number: 'Transporto priemonės medžiagos numeris',
        description: 'Aprašymas',
        time: 'Laikas',
        feature_ID: 'Ypatybės ID',
        feature_description: 'Ypatybės aprašymas',
        feature_code: 'Ypatybės kodas',
        eigenvalue_description: 'Savybės reikšmės aprašymas',
        chinese_description: 'Kinų kalbos aprašymas',
        supplier: 'Tiekėjas',
        bar_code_number: 'Barkodo numeris',
        scanning_time: 'Skanavimo laikas',
        key_component_type_code: 'Pagrindinės detalės tipo kodas',
        part_number: 'Detalės numeris',
        traceability_number: 'Sekamumo numeris',
        sub_key_type: 'Sub-pagrindinės detalės tipas',
        software: 'Programinė įranga',
        hardware: 'Aparatinė įranga',
        calibration_information: 'Kalibravimo informacija',
        supplier_name: 'Tiekėjo pavadinimas',
        pn: 'PIN kodas',
    },
    // 罗马尼亚
    roRO: {
        vin: 'VIN',
        productionTimeList: 'Listă timpuri de producție',
        vehicle_configuration_list: 'Listă configurații vehicul',
        accurately_traceable_parts_list: 'Listă piese urmăribile cu precizie',
        order_number: 'Număr comandă',
        order_type: 'Tip comandă',
        platform: 'Platformă',
        model_code: 'Cod model',
        date_of_production: 'Data producerii',
        certificate_of_conformity: 'Număr certificat de conformitate',
        certificate_printing_time: 'Timp imprimare certificat',
        vehicle_material_number: 'Număr material vehicul',
        description: 'Descriere',
        time: 'Timp',
        feature_ID: 'ID caracteristică',
        feature_description: 'Descriere caracteristică',
        feature_code: 'Cod caracteristică',
        eigenvalue_description: 'Descriere valoare proprie',
        chinese_description: 'Descriere în chineză',
        supplier: 'Furnizor',
        bar_code_number: 'Număr cod de bare',
        scanning_time: 'Timp scanare',
        key_component_type_code: 'Cod tip componentă cheie',
        part_number: 'Număr piesă',
        traceability_number: 'Număr urmărire',
        sub_key_type: 'Tip sub-componentă cheie',
        software: 'Software',
        hardware: 'Hardware',
        calibration_information: 'Informații calibrare',
        supplier_name: 'Nume furnizor',
        pn: 'Cod PIN',
    },
    // 挪威博克马尔
    nbNO: {
        vin: 'VIN',
        productionTimeList: 'Produksjonstidsoversikt',
        vehicle_configuration_list: 'Kjøretøykonfigurasjonsliste',
        accurately_traceable_parts_list: 'Nøyaktig sporbar del liste',
        order_number: 'Ordrenummer',
        order_type: 'Ordretype',
        platform: 'Plattform',
        model_code: 'Modellkode',
        date_of_production: 'Produksjonsdato',
        certificate_of_conformity: 'Samsvarsertifikatnummer',
        certificate_printing_time: 'Utskrivingstidspunkt for sertifikat',
        vehicle_material_number: 'Kjøretøymateriale nummer',
        description: 'Beskrivelse',
        time: 'Tid',
        feature_ID: 'Funksjons-ID',
        feature_description: 'Funksjonsbeskrivelse',
        feature_code: 'Funksjonskode',
        eigenvalue_description: 'Egenverdi beskrivelse',
        chinese_description: 'Kinesisk beskrivelse',
        supplier: 'Leverandør',
        bar_code_number: 'Strekkode nummer',
        scanning_time: 'Skanningstid',
        key_component_type_code: 'Nøkkelkomponent typekode',
        part_number: 'Reservedelsnummer',
        traceability_number: 'Sporbarhetsnummer',
        sub_key_type: 'Undernøkkelkomponenttype',
        software: 'Programvare',
        hardware: 'Maskinvare',
        calibration_information: 'Kalibreringsinformasjon',
        supplier_name: 'Leverandørnavn',
        pn: 'PIN-kode',
    },
    // 葡萄牙语巴西
    ptBX: {
        vin: 'VIN',
        productionTimeList: 'Lista de tempos de produção',
        vehicle_configuration_list: 'Lista de configuração do veículo',
        accurately_traceable_parts_list: 'Lista de peças rastreáveis com precisão',
        order_number: 'Número do pedido',
        order_type: 'Tipo de pedido',
        platform: 'Plataforma',
        model_code: 'Código do modelo',
        date_of_production: 'Data de produção',
        certificate_of_conformity: 'Número do certificado de conformidade',
        certificate_printing_time: 'Horário de impressão do certificado',
        vehicle_material_number: 'Número do material do veículo',
        description: 'Descrição',
        time: 'Tempo',
        feature_ID: 'ID do recurso',
        feature_description: 'Descrição do recurso',
        feature_code: 'Código do recurso',
        eigenvalue_description: 'Descrição do valor característico',
        chinese_description: 'Descrição em chinês',
        supplier: 'Fornecedor',
        bar_code_number: 'Número do código de barras',
        scanning_time: 'Horário da leitura',
        key_component_type_code: 'Código do tipo de componente-chave',
        part_number: 'Número da peça',
        traceability_number: 'Número de rastreabilidade',
        sub_key_type: 'Tipo de subcomponente-chave',
        software: 'Software',
        hardware: 'Hardware',
        calibration_information: 'Informações de calibração',
        supplier_name: 'Nome do fornecedor',
        pn: 'Código PIN',
    },
    // 瑞典语
    svSE: {
        vin: 'VIN',
        productionTimeList: 'Produktionstidlista',
        vehicle_configuration_list: 'Fordonskonfigurationslista',
        accurately_traceable_parts_list: 'Exakt spårbar del lista',
        order_number: 'Ordernummer',
        order_type: 'Ordertyp',
        platform: 'Plattform',
        model_code: 'Modellkod',
        date_of_production: 'Produktionsdatum',
        certificate_of_conformity: 'Certifikat för överensstämmelse nummer',
        certificate_printing_time: 'Utskriftstid för certifikat',
        vehicle_material_number: 'Fordonsmaterialnummer',
        description: 'Beskrivning',
        time: 'Tid',
        feature_ID: 'Funktions-ID',
        feature_description: 'Funktionsbeskrivning',
        feature_code: 'Funktionskod',
        eigenvalue_description: 'Egenvärdesbeskrivning',
        chinese_description: 'Kinesisk beskrivning',
        supplier: 'Leverantör',
        bar_code_number: 'Streckkodsnummer',
        scanning_time: 'Skanningstid',
        key_component_type_code: 'Nyckelkomponent typkod',
        part_number: 'Reservdelsnummer',
        traceability_number: 'Spårbarhetsnummer',
        sub_key_type: 'Undernyckelkomponenttyp',
        software: 'Mjukvara',
        hardware: 'Hårdvara',
        calibration_information: 'Kalibreringsinformation',
        supplier_name: 'Leverantörsnamn',
        pn: 'PIN-kod',
    },
    // 斯洛伐克
    skSK: {
        vin: 'VIN',
        productionTimeList: 'Zoznam výrobných časov',
        vehicle_configuration_list: 'Zoznam konfigurácií vozidla',
        accurately_traceable_parts_list: 'Zoznam presne sledovateľných súčiastok',
        order_number: 'Číslo objednávky',
        order_type: 'Typ objednávky',
        platform: 'Platforma',
        model_code: 'Kód modelu',
        date_of_production: 'Dátum výroby',
        certificate_of_conformity: 'Číslo certifikátu o zhode',
        certificate_printing_time: 'Čas tlače certifikátu',
        vehicle_material_number: 'Materiálové číslo vozidla',
        description: 'Popis',
        time: 'Čas',
        feature_ID: 'ID funkcie',
        feature_description: 'Popis funkcie',
        feature_code: 'Kód funkcie',
        eigenvalue_description: 'Popis vlastnej hodnoty',
        chinese_description: 'Čínsky popis',
        supplier: 'Dodávateľ',
        bar_code_number: 'Číslo čiarového kódu',
        scanning_time: 'Čas skenovania',
        key_component_type_code: 'Kód typu kľúčovej súčiastky',
        part_number: 'Číslo súčiastky',
        traceability_number: 'Sledovacie číslo',
        sub_key_type: 'Typ podkľúčovej súčiastky',
        software: 'Softvér',
        hardware: 'Hardvér',
        calibration_information: 'Informácie o kalibrácii',
        supplier_name: 'Meno dodávateľa',
        pn: 'PIN kód',
    },
    // 斯洛文尼亚
    slSI: {
        vin: 'VIN',
        productionTimeList: 'Seznam časov proizvodnje',
        vehicle_configuration_list: 'Seznam konfiguracij vozila',
        accurately_traceable_parts_list: 'Seznam natančno sledljivih delov',
        order_number: 'Številka naročila',
        order_type: 'Vrsta naročila',
        platform: 'Platforma',
        model_code: 'Koda modela',
        date_of_production: 'Datum proizvodnje',
        certificate_of_conformity: 'Številka potrdila o skladnosti',
        certificate_printing_time: 'Čas tiskanja potrdila',
        vehicle_material_number: 'Materialna številka vozila',
        description: 'Opis',
        time: 'Čas',
        feature_ID: 'ID funkcije',
        feature_description: 'Opis funkcije',
        feature_code: 'Koda funkcije',
        eigenvalue_description: 'Opis lastne vrednosti',
        chinese_description: 'Kitajski opis',
        supplier: 'Dobavitelj',
        bar_code_number: 'Številka črtne kode',
        scanning_time: 'Čas skeniranja',
        key_component_type_code: 'Koda tipa ključnega dela',
        part_number: 'Številka dela',
        traceability_number: 'Številka za sledljivost',
        sub_key_type: 'Podtip ključnega dela',
        software: 'Programska oprema',
        hardware: 'Strojna oprema',
        calibration_information: 'Informacije o umerjanju',
        supplier_name: 'Ime dobavitelja',
        pn: 'PIN koda',
    },
    // 泰语
    thTH: {
        vin: 'VIN',
        productionTimeList: 'รายการเวลาการผลิต',
        vehicle_configuration_list: 'รายการการกำหนดค่ารถยนต์',
        accurately_traceable_parts_list: 'รายการชิ้นส่วนที่สามารถติดตามได้อย่างแม่นยำ',
        order_number: 'หมายเลขคำสั่งซื้อ',
        order_type: 'ประเภทคำสั่งซื้อ',
        platform: 'แพลตฟอร์ม',
        model_code: 'รหัสรุ่น',
        date_of_production: 'วันที่ผลิต',
        certificate_of_conformity: 'หมายเลขใบรับรองความสอดคล้อง',
        certificate_printing_time: 'เวลาพิมพ์ใบรับรอง',
        vehicle_material_number: 'หมายเลขวัสดุของรถ',
        description: 'คำอธิบาย',
        time: 'เวลา',
        feature_ID: 'รหัสคุณสมบัติ',
        feature_description: 'คำอธิบายคุณสมบัติ',
        feature_code: 'รหัสคุณสมบัติ',
        eigenvalue_description: 'คำอธิบายค่าเฉพาะ',
        chinese_description: 'คำอธิบายภาษาจีน',
        supplier: 'ผู้จัดจำหน่าย',
        bar_code_number: 'หมายเลขบาร์โค้ด',
        scanning_time: 'เวลาสแกน',
        key_component_type_code: 'รหัสประเภทชิ้นส่วนสำคัญ',
        part_number: 'หมายเลขชิ้นส่วน',
        traceability_number: 'หมายเลขติดตาม',
        sub_key_type: 'ประเภทย่อยของชิ้นส่วนสำคัญ',
        software: 'ซอฟต์แวร์',
        hardware: 'ฮาร์ดแวร์',
        calibration_information: 'ข้อมูลการสอบเทียบ',
        supplier_name: 'ชื่อผู้จัดจำหน่าย',
        pn: 'รหัส PIN',
    },
    // 乌克兰语
    ukUA: {
        vin: 'VIN',
        productionTimeList: 'Список часів виробництва',
        vehicle_configuration_list: 'Список конфігурацій транспортного засобу',
        accurately_traceable_parts_list: 'Список точно відстежуваних деталей',
        order_number: 'Номер замовлення',
        order_type: 'Тип замовлення',
        platform: 'Платформа',
        model_code: 'Код моделі',
        date_of_production: 'Дата виробництва',
        certificate_of_conformity: 'Номер сертифіката відповідності',
        certificate_printing_time: 'Час друку сертифіката',
        vehicle_material_number: 'Номер матеріалу транспортного засобу',
        description: 'Опис',
        time: 'Час',
        feature_ID: 'ID характеристики',
        feature_description: 'Опис характеристики',
        feature_code: 'Код характеристики',
        eigenvalue_description: 'Опис власного значення',
        chinese_description: 'Китайський опис',
        supplier: 'Постачальник',
        bar_code_number: 'Номер штрих-коду',
        scanning_time: 'Час сканування',
        key_component_type_code: 'Код типу ключової деталі',
        part_number: 'Номер деталі',
        traceability_number: 'Номер для відстеження',
        sub_key_type: 'Тип підключової деталі',
        software: 'Програмне забезпечення',
        hardware: 'Апаратне забезпечення',
        calibration_information: 'Інформація про калібрування',
        supplier_name: 'Ім\'я постачальника',
        pn: 'PIN-код',
    },
    // 希腊语
    elGR: {
        vin: 'VIN',
        productionTimeList: 'Λίστα χρόνων παραγωγής',
        vehicle_configuration_list: 'Λίστα διαμόρφωσης οχήματος',
        accurately_traceable_parts_list: 'Λίστα ακριβώς ιχνηλατούμενων εξαρτημάτων',
        order_number: 'Αριθμός παραγγελίας',
        order_type: 'Τύπος παραγγελίας',
        platform: 'Πλατφόρμα',
        model_code: 'Κωδικός μοντέλου',
        date_of_production: 'Ημερομηνία παραγωγής',
        certificate_of_conformity: 'Αριθμός πιστοποιητικού συμμόρφωσης',
        certificate_printing_time: 'Ώρα εκτύπωσης πιστοποιητικού',
        vehicle_material_number: 'Αριθμός υλικού οχήματος',
        description: 'Περιγραφή',
        time: 'Ώρα',
        feature_ID: 'ID χαρακτηριστικού',
        feature_description: 'Περιγραφή χαρακτηριστικού',
        feature_code: 'Κωδικός χαρακτηριστικού',
        eigenvalue_description: 'Περιγραφή ιδιοτιμής',
        chinese_description: 'Κινεζική περιγραφή',
        supplier: 'Προμηθευτής',
        bar_code_number: 'Αριθμός γραμμωτού κώδικα',
        scanning_time: 'Ώρα σάρωσης',
        key_component_type_code: 'Κωδικός τύπου βασικού εξαρτήματος',
        part_number: 'Αριθμός εξαρτήματος',
        traceability_number: 'Αριθμός ιχνηλασιμότητας',
        sub_key_type: 'Υποτύπος βασικού εξαρτήματος',
        software: 'Λογισμικό',
        hardware: 'Υλικό',
        calibration_information: 'Πληροφορίες βαθμονόμησης',
        supplier_name: 'Όνομα προμηθευτή',
        pn: 'Κωδικός PIN',
    },
    // 爱沙尼亚
    etEE: {
        vin: 'VIN',
        productionTimeList: 'Tootmise ajaloend',
        vehicle_configuration_list: 'Sõiduki konfiguratsioonide loend',
        accurately_traceable_parts_list: 'Täpselt jälgitavate osade loend',
        order_number: 'Tellimuse number',
        order_type: 'Tellimuse tüüp',
        platform: 'Platvorm',
        model_code: 'Mudeli kood',
        date_of_production: 'Tootmise kuupäev',
        certificate_of_conformity: 'Vastavussertifikaadi number',
        certificate_printing_time: 'Sertifikaadi trükkimise aeg',
        vehicle_material_number: 'Sõiduki materjali number',
        description: 'Kirjeldus',
        time: 'Aeg',
        feature_ID: 'Funktsiooni ID',
        feature_description: 'Funktsiooni kirjeldus',
        feature_code: 'Funktsiooni kood',
        eigenvalue_description: 'Ominaisväärtuse kirjeldus',
        chinese_description: 'Hiina keelne kirjeldus',
        supplier: 'Tarnija',
        bar_code_number: 'Ribakoodi number',
        scanning_time: 'Skaneerimise aeg',
        key_component_type_code: 'Põhikomponendi tüübi kood',
        part_number: 'Osa number',
        traceability_number: 'Jälgitavuse number',
        sub_key_type: 'Alampõhikomponendi tüüp',
        software: 'Tarkvara',
        hardware: 'Riistvara',
        calibration_information: 'Kalibreerimise teave',
        supplier_name: 'Tarnija nimi',
        pn: 'PIN-kood',
    },
    // 哈萨克
    kkKZ: {
        vin: 'VIN',
        productionTimeList: 'Өндіру уақыты тізімі',
        vehicle_configuration_list: 'Көлік конфигурациясының тізімі',
        accurately_traceable_parts_list: 'Дәл ізделетін бөлшектер тізімі',
        order_number: 'Тапсырыс нөмірі',
        order_type: 'Тапсырыс түрі',
        platform: 'Платформа',
        model_code: 'Модель коды',
        date_of_production: 'Өндіру күні',
        certificate_of_conformity: 'Сәйкестік сертификатының нөмірі',
        certificate_printing_time: 'Сертификатты басып шығару уақыты',
        vehicle_material_number: 'Көлік материал нөмірі',
        description: 'Сипаттама',
        time: 'Уақыт',
        feature_ID: 'Ерекшелік ID',
        feature_description: 'Ерекшелік сипаттамасы',
        feature_code: 'Ерекшелік коды',
        eigenvalue_description: 'Мән сипаттамасы',
        chinese_description: 'Қытайша сипаттама',
        supplier: 'Жеткізуші',
        bar_code_number: 'Штрихкод нөмірі',
        scanning_time: 'Сканерлеу уақыты',
        key_component_type_code: 'Негізгі бөлшек түрінің коды',
        part_number: 'Бөлшек нөмірі',
        traceability_number: 'Іздеу нөмірі',
        sub_key_type: 'Ішкі негізгі бөлшек түрі',
        software: 'Бағдарламалық қамтамасыз ету',
        hardware: 'Құрылғы',
        calibration_information: 'Калибрлеу ақпараты',
        supplier_name: 'Жеткізуші атауы',
        pn: 'PIN коды',
    },
    // 希伯来语
    heIL: {
        vin: 'VIN',
        productionTimeList: 'רשימת זמני ייצור',
        vehicle_configuration_list: 'רשימת תצורות רכב',
        accurately_traceable_parts_list: 'רשימת חלקים ניתנים למעקב מדויק',
        order_number: 'מספר הזמנה',
        order_type: 'סוג הזמנה',
        platform: 'פלטפורמה',
        model_code: 'קוד דגם',
        date_of_production: 'תאריך ייצור',
        certificate_of_conformity: 'מספר תעודה של תאימות',
        certificate_printing_time: 'זמן הדפסת התעודה',
        vehicle_material_number: 'מספר חומר הרכב',
        description: 'תיאור',
        time: 'זמן',
        feature_ID: 'מזהה מאפיין',
        feature_description: 'תיאור מאפיין',
        feature_code: 'קוד מאפיין',
        eigenvalue_description: 'תיאור ערך עצמי',
        chinese_description: 'תיאור בסינית',
        supplier: 'ספק',
        bar_code_number: 'מספר ברקוד',
        scanning_time: 'זמן סריקת הברקוד',
        key_component_type_code: 'קוד סוג רכיב מפתח',
        part_number: 'מספר חלק',
        traceability_number: 'מספר מעקב',
        sub_key_type: 'תת סוג רכיב מפתח',
        software: 'תוכנה',
        hardware: 'חומרה',
        calibration_information: 'מידע על כיול',
        supplier_name: 'שם הספק',
        pn: 'קוד PIN',
    },
};
